import { useAuthStore } from '../stores/authStore';

/**
 * Centralized authentication handler for API interceptors and other services
 * This ensures consistent behavior when authentication fails across the application
 */
export class AuthHandler {
  private static instance: AuthHandler;
  
  private constructor() {}
  
  public static getInstance(): AuthHandler {
    if (!AuthHandler.instance) {
      AuthHandler.instance = new AuthHandler();
    }
    return AuthHandler.instance;
  }
  
  /**
   * Handle authentication failure (401 responses, expired tokens, etc.)
   * This method clears all authentication data and triggers a state change
   * that will be picked up by the useAuthRedirect hook
   */
  public handleAuthFailure(reason: string = 'Authentication failed'): void {
    console.log(`🔒 AuthHandler: ${reason}, clearing authentication state`);
    
    // Clear all tokens from localStorage
    localStorage.removeItem('authToken'); // Legacy token
    localStorage.removeItem('access-token');
    localStorage.removeItem('refresh-token');
    localStorage.removeItem('auth-storage'); // Zustand persisted state
    
    // Clear the Zustand auth store - this will trigger useAuthRedirect
    const { logout } = useAuthStore.getState();
    logout();
  }
  
  /**
   * Check if we should handle a 401 response
   * Avoids handling 401s on login/register endpoints to prevent loops
   */
  public shouldHandle401(url: string): boolean {
    const publicEndpoints = ['/auth/login', '/auth/register', '/auth/refresh', '/auth/forgot-password', '/auth/reset-password'];
    return !publicEndpoints.some(endpoint => url.includes(endpoint));
  }
}

// Export singleton instance
export const authHandler = AuthHandler.getInstance();